<template>
  <PageContainer title="Agendar aula prática">
    <div class="d-flex justify-content-center" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box v-else class="agendamento-container" space="medium">
      <form @submit.prevent="handleSubmit">
        <div class="inputs">
          <div class="inputs-row">
            <Select v-if="role === 2" :options="schemaOptions" legend="Auto escola" placeholder="Selecione uma auto escola"
              :modelValue="schema" @update:modelValue="$event => (schema = $event)" class="input-full" />

            <Input mask="###.###.###-##" legend="CPF" placeholder="000.000.000-00" :modelValue="cpf"
              @update:modelValue="$event => cpf = $event" class="input-full input-cpf" data-testid="input-cpf-agendamento" />

            <Input legend="Aluno" placeholder="Preencha o CPF do aluno" :modelValue="nomeAluno" readonly
              class="input-full" data-testid="input-nome-aluno-agendamento" />
          </div>
          <div class="inputs-row">
            <Select class="input-full" :options="instrutores" legend="Intrutor(a)"
              :placeholder="!instrutores.length ? 'Selecione uma auto escola' : 'Selecione um instrutor'"
              :modelValue="instrutor" @update:modelValue="$event => (instrutor = $event)" :disabled="loading" />

            <Select class="input-full" :options="veiculos" legend="Veículo"
              :placeholder="!veiculos.length ? 'Selecione uma auto escola' : 'Selecione um veículo'"
              :modelValue="veiculo" @update:modelValue="$event => (this.veiculo = $event)" :disabled="loading" />

            <Period legend="Data" :firstModelValue="initialDate" :secondModelValue="finalDate"
              @update:firstModelValue="$event => (this.initialDate = $event)"
              @update:secondModelValue="$event => (this.finalDate = $event)" :disabled="loading" />
          </div>
        </div>

        <div class="buttons">
          <Button v-if="availables.length < 1" type="button" @handle:click="clearInputs" text="Limpar" :fill="false"
            color="danger" :disabled="loading" data-testid="button-limpar-agendamento">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Consultar" color="primary" :disabled="loading">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div class="d-flex justify-content-center" v-if="loading">
        <LoadingSpinner />
      </div>

      <template v-else-if="availables.length > 0 && !loading">
        <div class="table-container">
          <Table :headers="['Data', 'Hora', 'Ações']">
            <tr v-for="(date, index) in availables" :key="index">
              <td>{{ date.data }}</td>
              <td>
                <div class="hora-container">
                  <div class="input-hora" v-for="(horario, hIndex) in date.horarios" :key="hIndex">
                    <input type="time" class="input-hora" v-model="date.horarios[hIndex].data" />

                    <Button v-if="date.horarios.length > 1 && hIndex !== date.horarios.length - 1"
                      @handle:click="removeHorario(index, hIndex)" text="" color="danger">
                      <Close :size="18" />
                    </Button>

                    <Button v-else @handle:click="addHorario(index)" text="" color="primary">
                      <Plus :size="18" />
                    </Button>

                    <div class="checkbox">
                      <label>
                        Aula dupla
                        <input type="checkbox" v-model="date.horarios[hIndex].is_double" />
                        <span></span>
                      </label>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div>
                  <IconButton @handle:click="removeDate(date.data)" color="danger" title="Remover data">
                    <TrashCanOutline :size="19" />
                  </IconButton>
                </div>
              </td>
            </tr>
          </Table>

          <div class="buttons">
            <Button type="button" @handle:click="clearHours" text="Limpar" :fill="false" color="danger"
              :disabled="loading || loadingSchedule">
              <CloseCircleOutline :size="18" />
            </Button>

            <Button type="button" @handle:click="openModalConfirmation" text="Confirmar agendamento" color="primary"
            :disabled="loading || loadingSchedule || loadingCreditCheck">
              <Check :size="18" />
            </Button>
          </div>
        </div>
      </template>
    </Box>

    <Box v-if="!loading && Object.keys(unavailables).length > 0" class="indisponiveis-container" space="medium">
      <h3>Horários indisponíveis para esse instrutor</h3>

      <div class="datas">
        <div class="data" v-for="(unavailable, data) in unavailables" :key="data">
          <span>{{ utils.formatOnlyDate(data) }}</span>

          <div class="horarios-card">
            <div class="categoria" v-for="(horarios, categoria) in unavailable" :key="categoria">
              <span>Categoria {{ categoria }}</span>

              <div class="horarios">
                <Badge v-for="(horario, index) in horarios" :key="index" :text="horario" color="danger" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>

    <ConfirmScheduleModal ref="confirmScheduleModal" :onConfirm="handleSchedule" />

    <CreditWarningModal ref="creditWarningModal" :onConfirm="handleCreditWarningConfirm" />

    <OnSuccessModal @confirm="handleSubmit" ref="onSucessModal" />
  </PageContainer>
</template>

<script>
import utils from '../../services/utils'

import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Select from 'core/Select'
import Input from 'core/Input'
import Period from 'core/Period'
import Button from 'core/Button'
import Table from 'core/Table'
import Paginate from 'core/Paginate'
import Badge from 'core/Badge'
import IconButton from 'core/IconButton'
import LoadingSpinner from 'core/LoadingSpinner'
import ConfirmScheduleModal from './ConfirmScheduleModal'
import OnSuccessModal from './OnSuccessModal'
import CreditWarningModal from './CreditWarningModal'

import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'
import Plus from 'icons/Plus'
import Close from 'icons/Close'
import Check from 'icons/Check'
import TrashCanOutline from 'icons/TrashCanOutline'

export default {
  name: 'form-agendamento',
  components: {
    PageContainer,
    Box,
    Select,
    Input,
    Period,
    Button,
    Table,
    Paginate,
    Badge,
    IconButton,
    LoadingSpinner,
    ConfirmScheduleModal,
    OnSuccessModal,
    CreditWarningModal,

    CloseCircleOutline,
    Magnify,
    Plus,
    Close,
    Check,
    TrashCanOutline,
  },
  data() {
    return {
      utils: utils,
      role: Number(localStorage.id_role),
      schema: null,
      cpf: '',
      nomeAluno: '',
      idAluno: '',
      instrutor: '',
      veiculo: '',
      initialDate: '',
      finalDate: '',
      schemaOptions: [],
      instrutores: [],
      veiculos: [],
      availables: [],
      unavailables: [],
      loaded: false,
      loading: false,
      loadingSchedule: false,
      loadingCreditCheck: false,
    }
  },
  async created() {
    if (this.role === 2) {
      await this.fetchCfcs()
    } else {
      await Promise.all([
        this.fetchInstrutores(),
        this.fetchVeiculos(),
      ])
    }

    this.loaded = true
  },
  methods: {
    async fetchCfcs() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then((res) => {
          this.schemaOptions = res.body.dados.map(cfc => ({ value: cfc.tenant_schema, text: cfc.nome_fantasia }))
        })
        .catch((error) => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async fetchInstrutores(schema) {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/instrutor/fetch${schema ? `?schema=${schema}` : ''}`)
        .then(res => {
          this.instrutores = res.body.dados.map(instrutor => ({ value: instrutor.id_instrutor, text: instrutor.nome }))
        })
        .catch(err => {
          console.log(err)

          this.$toasted.show('Erro ao buscar instrutores.', {
            position: 'top-right',
          })
        })
    },
    async fetchVeiculos(schema) {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/veiculo${schema ? `?schema=${schema}` : ''}`)
        .then(res => {
          this.veiculos = res.body.map(veiculo => ({ value: veiculo.id_veiculo, text: `Categoria ${veiculo.categoria.categoria_cnh} / ${veiculo.placa}` }))
        })
        .catch(err => {
          console.log(err)

          this.$toasted.show('Erro ao buscar veículos.', {
            position: 'top-right',
          })
        })
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        this.loading = true

        await this.fetchUnavailable()

        this.loading = false
      }
    },
    validateInputs() {
      if (!this.cpf || !this.idAluno || !this.instrutor || !this.veiculo || !this.initialDate || !this.finalDate) {
        this.$toasted.show('Preencha todos os campos.', {
          position: 'top-right',
        })

        return false
      }

      return true
    },
    async fetchUnavailable() {
      const params = {
        id_aluno: this.idAluno,
        id_instrutor: this.instrutor,
        id_veiculo: this.veiculo,
        initialDate: this.initialDate,
        finalDate: this.finalDate,
      }

      if (this.schema) params.schema = this.schema

      await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/aulas/praticas/horarios-indisponiveis`, params)
        .then(res => {
          this.unavailables = res.body.dados

          const availables = []

          const initialDate = new Date(`${this.initialDate} 00:00:00`)
          const finalDate = new Date(`${this.finalDate} 00:00:00`)

          const dates = []
          let currentDate = new Date(initialDate)

          while (currentDate <= finalDate) {
            if (currentDate.getDay() !== 0) {
              dates.push(new Date(currentDate))
            }

            currentDate.setDate(currentDate.getDate() + 1)
          }

          dates.forEach(date => {
            availables.push({
              data: this.utils.formatOnlyDate(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`),
              horarios: [{
                data: '',
                is_double: false,
              }],
            })
          });

          this.availables = availables
        })
        .catch(err => {
          this.unavailables = []
          this.availables = []

          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    addHorario(index) {
      this.availables[index].horarios.push({ data: '', is_double: false, });
    },
    removeHorario(index, hIndex) {
      this.availables[index].horarios.splice(hIndex, 1);
    },
    clearHours() {
      this.availables.forEach(date => {
        date.horarios = [{ data: '', is_double: false, }];
      });
    },
    openModalConfirmation() {
      const hasEmptyHorario = this.availables.some(date =>
        date.horarios.some(horario => !horario.data)
      )

      if (hasEmptyHorario) {
        this.$toasted.show('Preencha todos os horários.', {
          position: 'top-right',
        })

        return
      }

      const datas = []

      this.availables.forEach(date => {
        date.horarios.forEach(horario => {
          const [day, month, year] = date.data.split('/');
          const fullDate = `${year}-${month}-${day} ${horario.data}:00`

          datas.push({
            data: fullDate,
            is_double: horario.is_double,
          })
        })
      })

      const data = {
        id_aluno: this.idAluno,
        id_instrutor: this.instrutor,
        id_veiculo: this.veiculo,
        aluno: this.nomeAluno,
        cpf: this.cpf,
        instrutor: this.instrutores.find(item => item.value === this.instrutor),
        veiculo: this.veiculos.find(item => item.value === this.veiculo),
        datas,
      }

      if (this.schema) {
        data.schema = this.schema
      }

      this.checkCreditBlock(data)
    },
    async checkCreditBlock(data) {
      this.loadingCreditCheck = true

      const url = `${process.env.VUE_APP_URL_API_V2}/alunos/consultar/bloqueio/pratico/id/${this.idAluno}${this.schema ? `?schema=${this.schema}` : ''}`

      await this.$http.get(url)
        .then(res => {
          const bloqueio = res.body.bloqueio

          // Adiciona flag de consumo de créditos aos dados
          data.consumirCreditos = bloqueio === true

          if (bloqueio === true) {
            this.$refs.creditWarningModal.open(data)
          } else {
            this.$refs.confirmScheduleModal.open(data)
          }
        })
        .catch(err => {
          const mensagem = err.body && err.body.mensagem ? err.body.mensagem : 'Erro ao verificar bloqueio de créditos.'
          this.$toasted.show(mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loadingCreditCheck = false
        })
    },
    handleCreditWarningConfirm(data) {
      this.$refs.confirmScheduleModal.open(data)
    },
    async handleSchedule(data) {
      this.loadingSchedule = true

      await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/aulas/praticas/agendar`, data)
        .then(res => {
          this.handleOpenSuccessModal()
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.$refs.confirmScheduleModal.close()
        })

      this.loadingSchedule = false
    },
    handleOpenSuccessModal() {
      this.$refs.onSucessModal.open()
    },
    clearInputs() {
      this.schema = null
      this.cpf = ''
      this.nomeAluno = ''
      this.idAluno = ''
      this.instrutor = ''
      this.veiculo = ''
      this.initialDate = ''
      this.finalDate = ''
      this.availables = []
      this.unavailables = {}
    },
    removeDate(data) {
      const dateIndex = this.availables.findIndex(item => item.data === data)

      this.availables = this.availables.filter((item, index) => index !== dateIndex)
    },
  },
  watch: {
    async cpf(current, old) {
      if (current.length === 11) {
        if (this.role === 2 && !this.schema) {
          this.cpf = ''

          return this.$toasted.show('Selecione uma auto escola e tente novamente.', {
            position: 'top-right',
          })
        }

        await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/alunos/${current}${this.schema ? `?schema=${this.schema}` : ''}`)
          .then((res) => {
            this.nomeAluno = res.body.dados.nome
            this.idAluno = res.body.dados.id_aluno
          })
          .catch(err => {
            this.nomeAluno = ''
            this.idAluno = ''
            this.$toasted.show('CPF inválido ou não encontrado na base da autoescola, verifique o CPF informado e tente novamente.', {
              position: 'top-right',
            })
          })
      } else {
        // Limpa o nome e ID do aluno quando o CPF não tiver 11 dígitos
        if (this.nomeAluno || this.idAluno) {
          this.nomeAluno = ''
          this.idAluno = ''
        }
      }
    },
    async schema(current, old) {
      if (current) {
        this.availables = []
        this.instrutor = ''
        this.veiculo = ''
        this.cpf = ''
        this.nomeAluno = ''
        this.initialDate = ''
        this.finalDate = ''

        await Promise.all([
          this.fetchInstrutores(current),
          this.fetchVeiculos(current),
        ])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.agendamento-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }

        .input-cpf {
          max-width: 19.6875rem;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .hora-container {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .input-hora {
        flex: 1;

        display: flex;
        align-items: center;
        gap: 0.5rem;

        .input-hora {
          max-width: 15.875rem;
          width: 100%;
          height: 2.738125rem;
          outline: 0;
          padding: 0.625rem;
          border: 1px solid #EAEAEA;
          border-radius: 4px;
          font-size: 1rem;
          font-weight: 600;
          line-height: 21.82px;
        }

        .checkbox {
          label {
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 0.75rem;
            font-size: 0.875rem;
            font-weight: 600;
            line-height: 19.1px;
            color: #606264;
            cursor: pointer;

            input[type="checkbox"] {
              display: none;
            }

            span {
              position: relative;
              display: inline-block;
              width: 1rem;
              height: 1rem;
              border: 2px solid #DFDCDC;
              border-radius: 2px;
              background-color: #FAFAFA;
              transition: background-color 0.2s, border-color 0.2s;
            }

            input[type="checkbox"]:checked+span {
              background-color: #1C2D5A;
            }

            input[type="checkbox"]:checked+span::after {
              content: '✓';
              color: white;
              font-size: 8px;
              position: absolute;
              top: 55%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }
}

.indisponiveis-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #606264;
  }

  .datas {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;

    .data {
      padding: 1rem;
      background: #F1F1F1;
      border-radius: 8px;

      display: flex;
      flex-direction: column;
      gap: 1rem;

      >span {
        font-size: 1rem;
        font-weight: 600;
        color: #202224;
      }

      .horarios-card {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 1rem;

        .categoria {
          display: flex;
          flex-direction: column;
          gap: 1rem;

          >span {
            font-size: 0.875rem;
            font-weight: 500;
            color: #000000;
          }

          .horarios {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;

            >span {
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
